import { render, staticRenderFns } from "./WebBoard.vue?vue&type=template&id=23d9a288&"
import script from "./WebBoard.vue?vue&type=script&lang=js&"
export * from "./WebBoard.vue?vue&type=script&lang=js&"
import style0 from "./WebBoard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports